import React                from 'react'
import { inject, observer } from 'mobx-react'

import { DeleteButton     } from '../../components/delete'

export const DeleteTextButton = inject('textsStore')(observer(({textsStore,entry}) =>
<DeleteButton tag="message" title="text.delete" onClick={textsStore.remove(entry)} />))
